// extracted by css-extract-rspack-plugin
export default {"root":"XIS96KqF9rwvjJ0B"};